import { forwardRef, Fragment, useContext, useEffect, useMemo } from 'react'
import { FilterContext } from 'features/dashboard/filter/FilterContext'
import { createPortal } from 'react-dom'
import { FilterMenus, FilterTypes } from 'features/dashboard/filter/FilterSpecs'
import Button from 'components/form/Button'
import { batch, useDispatch } from 'react-redux'
import {
  addFilter,
  fetchBizChannels,
  fetchTrackerRights,
} from 'features/dashboard/filter/dashboardFilterSlice'
import InputForm from 'features/dashboard/filter/form/InputForm'
import CheckBoxForm from 'features/dashboard/filter/form/CheckBoxForm'
import { campaignTableActions } from 'features/dashboard/table/campaign/campaignTableSlice'
import { adGroupTableActions } from 'features/dashboard/table/adGroup/adGroupTableSlice'
import { keywordTableActions } from 'features/dashboard/table/keyword/keywordTableSlice'
import { creativeTableActions } from 'features/dashboard/table/creative/creativeTableSlice'

const FilterFormLayer = forwardRef((props, ref) => {
  const { formVisible, hideFilterFormLayer, filterForm, filterRef } =
    useContext(FilterContext)
  const { left, bottom } = filterRef?.current?.getBoundingClientRect() || {
    left: 0,
    bottom: 0,
  }
  const handleOutsideClick = event => {
    if (ref.current && !ref.current.contains(event.target)) {
      hideFilterFormLayer()
    }
  }
  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick)
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick)
    }
  })
  const dispatch = useDispatch()
  const { domain, key, data } = filterForm
  const domainName = FilterMenus[domain].title
  const { title, filterType } = useMemo(
    () => FilterMenus[domain].subs.find(sub => sub.key === key),
    [domain, key]
  )
  const isEmpty = useMemo(() => {
    if (filterType === FilterTypes.MULTI) {
      return data.value.trim() === '' && data.checked === false
    } else if (filterType === FilterTypes.CHECKBOX) {
      return data.values.length === 0
    } else {
      return data.value.trim() === ''
    }
  }, [data, filterType])
  const className = useMemo(() => {
    if (key === 'bizChannels' || key === 'trackers') {
      return 'layer_campaign_biz'
    } else if (filterType === FilterTypes.CHECKBOX) {
      return 'layer_campaign_biz'
    } else if (key === 'id' || key === 'creatives') {
      return 'layer_inptype layer_campaign_id'
    } else if (key === 'name' || key === 'text') {
      return 'layer_inptype layer_material_name'
    } else {
      return 'layer_inptype layer_boardsearch'
    }
  }, [key, filterType])

  useEffect(() => {
    if (formVisible && key === 'bizChannels') {
      dispatch(fetchBizChannels())
    } else if (formVisible && key === 'trackers') {
      dispatch(fetchTrackerRights())
    }
  }, [dispatch, formVisible, key])

  const container = document.getElementById('kakaoContent')
  const { top: containerTop, left: containerLeft } = container
    ? container.getBoundingClientRect()
    : {
        top: 0,
        left: 0,
      }

  return container ? (
    createPortal(
      <div
        ref={ref}
        className={`basic_layer4 ${className}`}
        style={{
          display: filterRef.current && formVisible ? 'block' : 'none',
          position: 'absolute',
          top: bottom - containerTop + 8,
          left: left - containerLeft + 4,
          margin: 0,
        }}>
        <div className="inner_basic_layer">
          <strong className="tit_layer">
            {title.startsWith(domainName) ? title : `${domainName} ${title}`}
          </strong>
          <div className="con_layer">
            {filterType === FilterTypes.CHECKBOX ? (
              <CheckBoxForm />
            ) : (
              <InputForm />
            )}
          </div>
          <div className="btn_group">
            <Button onClick={hideFilterFormLayer}>취소</Button>
            <Button
              primary
              disabled={isEmpty}
              onClick={() => {
                if (!isEmpty) {
                  batch(() => {
                    dispatch(addFilter(filterForm))
                    dispatch(campaignTableActions.setPage(0))
                    dispatch(adGroupTableActions.setPage(0))
                    dispatch(keywordTableActions.setPage(0))
                    dispatch(creativeTableActions.setPage(0))
                  })
                  hideFilterFormLayer()
                }
              }}>
              적용
            </Button>
          </div>
        </div>
      </div>,
      container
    )
  ) : (
    <Fragment />
  )
})
FilterFormLayer.displayName = 'FilterFormLayer'
export default FilterFormLayer
